import { render, staticRenderFns } from "./NewClientForm1.vue?vue&type=template&id=1a029981&scoped=true"
import script from "./NewClientForm1.ts?vue&type=script&lang=ts&external"
export * from "./NewClientForm1.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a029981",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a029981')) {
      api.createRecord('1a029981', component.options)
    } else {
      api.reload('1a029981', component.options)
    }
    module.hot.accept("./NewClientForm1.vue?vue&type=template&id=1a029981&scoped=true", function () {
      api.rerender('1a029981', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/ProcessesForms/components/P42/NewClientForm1/NewClientForm1.vue"
export default component.exports